module.exports = __webpack_public_path__ + "img/second-univ-bg.ac8e0a4e.png";